<script>
import apiServices from "@/services/yungol-services";
export default {
  template: `<div class="buttons is-justify-end" style='width: 100%; height: 100%; margin: auto; margin-top: 2px'>
    <button class="button" :class="params.data.active ? 'is-dark' : 'is-grey'" v-on:click="switchStatus()">
          <span v-tooltip="params.data.active ? 'Deshabilitar' : 'Habilitar' + ' proceso'" class="icon">
            <i class="material-icons">{{ params.data.active ? 'toggle_on' : 'toggle_off' }}</i>
          </span>
    </button>
    <button class="button is-link" @click="selectedComp()">
        <span v-tooltip="'Histórico de comparación'" class="icon">
          <i class="material-icons">compare_arrows</i>
        </span>
    </button>
    <button class="button is-dark" @click="copyLink()">
      <span v-tooltip="'Link de acceso'" class="icon">
        <i class="material-icons">share</i>
      </span>
    </button>
    <button class="button is-success" v-on:click="editProcess()">
        <span v-tooltip="'Editar'" class="icon">
          <i class="material-icons">edit</i>
        </span>
    </button>
    <button class="button is-danger" v-on:click="deleteProcess()">
      <span v-tooltip="'Eliminar'" class="icon">
        <i class="material-icons">delete_forever</i>
      </span>
    </button>
  </div>`,
  data() {
    return {
      params: this.$parent.params,
    };
  },
  methods: {
    // Actions
    editProcess() {
      this.$emit("editProcess", this.params.data);
    },
    async deleteProcess() {
      const config = {
        title: "¿Estás seguro?",
        text:
          "Al eliminar no se podrá recuperar el proceso después y se eliminarán todos los empleados.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, eliminar",
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const deleteAttached = this.$fire.deleteFolderAttached(
              this.params.value,
            );
            if (!deleteAttached) {
              await this.$store.dispatch("notify", {
                message: "Error al eliminar los anexos.",
                type: "is-danger",
                duration: 4000,
                position: "top-center",
              });
            } else {
              const result = await apiServices.delete(
                `/deletecohorteclima/${this.params.value}`,
              );
              if (result.data) {
                await this.$swal({
                  text: "Proceso eliminado correctamente.",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1700,
                });
                this.$emit("getProcesses");
                /*
                this.params.api.applyTransaction({
                  remove: [this.params.node.data],
                }); */
              }
            }
          } catch (err) {
            await this.$swal({
              text: "Error al eliminar el proceso.",
              icon: "error",
              showConfirmButton: false,
              timer: 1700,
            });
            console.log(err);
          }
        }
      });
    },
    selectedComp() {
      this.$emit("selectedComp", this.params.data);
    },
    async switchStatus() {
      try {
        const result = await apiServices.post("activecohorteclima", {
          idProcess: this.params.data._id,
          newStatus: !this.params.data.active,
        });
        if (result.data) {
          if (this.params.data) {
            const newData = { ...this.params.data, active: result.data.active };
            this.params.node.setData(newData);
          }

          await this.$store.dispatch("notify", {
            message: `Se ha ${
              !this.params.data.active ? "habilitado" : "deshabilitado"
            } el proceso.`,
            type: "is-link",
          });
        }
      } catch (e) {
        await this.$store.dispatch("notify", {
          message: `Error al ${
            !this.params.data.status ? "Habilitar" : "Deshabilitar"
          } el proceso.`,
          type: "is-danger",
        });
      }
    },
    copyLink() {
      let textArea = document.createElement("textarea");

      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = "2em";
      textArea.style.height = "2em";

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = "transparent";

      textArea.value =
        window.location.host + "/accesoclima/" + this.params.data.codigo;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        let successful = document.execCommand("copy");
        let msg = successful ? "¡Copiado al portapapeles!" : "Error al copiar";
        let type = successful ? "is-link" : "is-danger";

        this.$store.dispatch("notify", {
          message: msg,
          type: type,
        });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Error al copiar",
          type: "is-danger",
        });
      }
      document.body.removeChild(textArea);
    },
  },
};
</script>

<style lang="scss">
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/buttonsActionProcess.vue